import styled from "styled-components";
import { useState, useContext, useEffect, createContext } from "react";
import NotificationsSettings from "../Components/Settings/Notifications/NotificationsSettings";
import { DialogWindowContext } from "./DialogueWindowContext";
import { CurrentUserContext } from "./CurrentUserContext";
import { isSupported } from "firebase/messaging";
import { listenToExistingNotificationProfile, messaging } from "../Firebase";
import { onMessage } from "firebase/messaging";

export const NotificationContext = createContext<NotificationProfile | null>(
  null
);

export default function NotificationContextProvider(props: Props) {
  const [notificationProfile, setNotificationProfile] =
    useState<NotificationProfile | null>(null);
  const currentUser = useContext(CurrentUserContext);
  const DialogWindow = useContext(DialogWindowContext);
  const userData = currentUser?.currentUser;

  const showNotificationWindowHandler = () => {
    DialogWindow.setDialogProps((prevProps) => ({
      ...prevProps,
      showEditWindow: true,
      onClose: () => {
        const now = new Date().getTime();
        localStorage.setItem(
          "notificationBannerClosedTimestamp",
          now.toString()
        );
      },
      header: `Notifications`,
      children: <NotificationsSettings />,
    }));
  };

  useEffect(() => {
    const checkAndShowNotification = async () => {
      try {
        if (!isSupported() || typeof Notification === "undefined") return;
        if (Notification.permission !== "granted") {
          showNotificationWindowHandler();
        } else if (Notification.permission === "granted") {
          const msg = await messaging();
          if (!msg) {
            console.error("Messaging is not supported in this browser.");
            return;
          }
          onMessage(msg, (message) => {
            console.log("Received foreground notification. ", message);
            if (
              message.data &&
              message.data.title &&
              message.data.body
            ) {
              new Notification(message.data.title, {
                body: message.data.body,
                icon: message.data.icon,
                tag: message.data.tag,
              });
            }
          });
        }
      } catch (error) {
        console.error("Error checking and showing notification:", error);
      }
    };
    if (!userData) return;
    checkAndShowNotification();
    const unsubscribeFromNotificationProfile =
      listenToExistingNotificationProfile(
        userData.userId,
        (notificationProfileFromServer) => {
          const timestamp = localStorage.getItem("pwabannerClosedTimestamp");
          const oneWeek = 7 * 24 * 60 * 60 * 1000;
          const now = new Date().getTime();
          if (!timestamp || now - Number(timestamp) > oneWeek) {
            setNotificationProfile(notificationProfileFromServer);
          }
        }
      );
    return () => {
      unsubscribeFromNotificationProfile();
    };
  }, [userData]);

  return (
    <NotificationContext.Provider value={notificationProfile}>
      {props.children}
    </NotificationContext.Provider>
  );
}

interface Props {
  children: React.ReactNode;
}
